import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { theme } from '#app/theme'
import '#app/i18n'
import IndexPage from '#app/pages/IndexPage'
import LoginPage from '#app/pages/LoginPage'
import ConsentPage from '#app/pages/ConsentPage'

const container = document.getElementById('root')
if (!container) {
    throw new Error('Root element #root not found')
}

createRoot(container).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Suspense fallback={null}>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<IndexPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/consent" element={<ConsentPage />} />
                    </Routes>
                </BrowserRouter>
            </Suspense>
        </ThemeProvider>
    </StrictMode>
)
